// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"948cd175","732":"f489abbc","977":"5253e93c"}[chunkId] + ".chunk.js";
};